import { useContext } from 'react'
import { StructsContextCore } from '../StructsContext'

export const useAddRemoveStructs = () => {
  const structs = useContext(StructsContextCore)
  return { add: structs.add, remove: structs.remove, removeByKey: structs.removeByKey }
}
